import moment, { Moment } from "moment";
import { SearchPeriod } from "types/search/form";
import { DateFactory } from "./dateFactory";
import { PresetOption } from "components/common/DateFilter/types";

export const getPeriodDates = (period: SearchPeriod) => {
	let beginDate: Moment | null = null;
	let endDate: Moment | null = null;
    
	if (period === 'last_week') {
		beginDate = moment().subtract(1, 'week');
		endDate = moment();
	} else if (period === 'last_month') {
		beginDate = moment().subtract(1, 'month');
		endDate = moment();
	} else if (period === 'last_three_months') {
		beginDate = moment().subtract(3, 'months');
		endDate = moment();
	} else if (period === 'next_fifteen_days') {
		beginDate = moment();
		endDate = moment().add(15, 'days');
	}

	return { beginDate, endDate };
};

export const getPeriodPresetOptions = (): PresetOption[] => [{
	label: 'Last week',
	range: () => ({...DateFactory.getPastDateRangeFor('week'), period: 'last_week'})
}, {
	label: 'Last month',
	range: () => ({...DateFactory.getPastDateRangeFor('month'), period: 'last_month'})
}, {
	label: 'Last 3 months',
	range: () => ({...DateFactory.getPastDateRangeFor('month', 3), period: 'last_three_months'})
}, {
	label: 'Next 15 days',
	range: () => ({...DateFactory.getFutureDateRangeFor('day', 15), period: 'next_fifteen_days'})
}];